// extracted by mini-css-extract-plugin
export var acitonButtons = "_f6-0";
export var additionalIcon = "_f6-f";
export var block = "_f6-1";
export var blockContent = "_f6-7";
export var blockDescription = "_f6-8";
export var blockIcon = "_f6-9";
export var blockTitle = "_f6-6";
export var border = "_f6-a";
export var center = "_f6-l";
export var edge = "_f6-b";
export var edgeLabel = "_f6-c";
export var edgePath = "_f6-d";
export var error = "_f6-e";
export var flowchart = "_f6-g";
export var flowchartContent = "_f6-h";
export var highlighted = "_f6-3";
export var hover = "_f6-4";
export var icon = "_f6-i";
export var left = "_f6-m";
export var navButton = "_f6-j";
export var navButtons = "_f6-k";
export var right = "_f6-n";
export var selected = "_f6-2";
export var small = "_f6-5";